import {Table } from 'antd'
import React, { useEffect, useState } from 'react'
import IncomeEdit from './IncomeEdit';
import Copy from '../../cpn/Copy';
import ReportCheck from '../report/ReportCheck';
import classes from './income.module.css';
import StateTag from '../../cpn/StateTag';
function IncomeListPendding(props) {
    const [list,setList] = useState([]);   
    useEffect(() => {
        if (props.list) {
            let arr = props.list.filter((item) => item.ddsr_state === '1' && item.ddsr_uid === props.yh_id);            
            arr.sort((a, b) => new Date(b.ddsr_ctime) - new Date(a.ddsr_ctime));
            // Ensure each item has a unique key property
            arr = arr.map((item) => ({
                ...item,
                key: item.key || item.ddsr_id
            }));
            setList(arr);
        }
    }, [props.list, props.yh_id])
    
    const columns = [    
        {
            title: '收款客户',
            dataIndex: 'ddsr_kh_name',
            width: '12%',
            key: 'ddsr_kh_name',         
            render: (text, record) => <IncomeEdit 
                                        ddsr_id={record.key} 
                                        yh_id={props.yh_id}
                                        yh_name={props.yh_name}
                                        ddsr_bzd_id={record.ddsr_bzd_id}
                                        ddsr_price={record.ddsr_price}
                                        ddsr_content={record.ddsr_content}
                                        ddsr_date={record.ddsr_date}
                                        ddsr_date_end={record.ddsr_date_end}
                                        ddsr_bzd_name={record.ddsr_bzd_name}
                                        ddsr_bzd_danhao={record.ddsr_bzd_danhao}
                                        ddsr_type_id={record.ddsr_type_id}
                                        ddsr_type_name={record.ddsr_type_name}
                                        ddsr_kh_id={record.ddsr_kh_id}
                                        ddsr_kh_name={record.ddsr_kh_name}
                                        qy_id={props.qy_id}
                                        qy_name={props.qy_name}
                                        ddsr_num={record.ddsr_num}
                                        ddsr_amount={record.ddsr_amount}
                                        ddsr_state={record.ddsr_state}
                                        ddsr_bm_id={record.ddsr_bm_id}
                                        ddsr_bm_name={record.ddsr_bm_name}
                                        ddsr_khyhzh_id={record.ddsr_khyhzh_id}
                                        ddsr_khyhzh_name={record.ddsr_khyhzh_name}
                                        ddsr_image_name={record.ddsr_image_name}
                                        ddsr_image_file={record.ddsr_image_file}
                                        ddsr_ctime={record.ddsr_ctime}
                                    />
        },
        {
            title: '收款金额',
            dataIndex: 'ddsr_amount',
            width: '10%',
            key: 'ddsr_amount',   
            render: (text, record) => <span style={{color:'red'}}>￥{Number(text).toLocaleString('zh-CN', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })}</span>
        },
        {
            title: '收款事由',
            dataIndex: 'ddsr_name',
            key:'ddsr_name',
            render:(text) => <Copy title={text}/>
        },   
        {
            title: '团队名称',
            width: '10%', 
            dataIndex:"ddsr_bzd_danhao",
            key:'ddsr_bzd_danhao',
            render:(text,record) => {
                return <ReportCheck  dsbzd_name={record.ddsr_bzd_name} dsbzd_id={record.ddsr_bzd_id} dsbzd_danhao={record.ddsr_bzd_danhao} yh_id={props.yh_id}  yh_name={props.yh_name} qy_id={props.qy_id} qy_name={props.qy_name}/>
            }
        },      
        {
            title: '状态',
            dataIndex: 'ddsr_state',
            width: '5%',
            key: 'ddsr_state',            
            render:(text) => <StateTag state={text} />
        },
        {
            title: '编号',
            dataIndex: 'key',
            width: '5%',
            key: 'key',            
        },
        
    ]
    return (
        <>                            
            {/* <Flex style={{ marginBottom: "10px" }} justify='space-between' align='center'>
                <Form 
                    name='income' 
                    layout='inline' 
                    form={form}
                    onFinish={(values) => {
                        console.log(values,'values');
                        setQuery(prev => ({
                            ...prev, 
                            ddsr_content: values.ddsr_content ? values.ddsr_content : '', 
                            ddsr_kh_id: values.ddsr_kh_id ? values.ddsr_kh_id : '',
                            ddsr_bzd_danhao: values.ddsr_bzd_danhao ? values.ddsr_bzd_danhao : '',
                        }))
                    }}
                    initialValues={{
                        ddsr_content:'',
                        ddsr_kh_id:'',
                        ddsr_bzd_danhao:'',
                    }}
                >
                    <Form.Item name='ddsr_kh_id'>
                        <ClientSelect
                            wrapperCol={null}
                            qy_id={props.qy_id}
                            qy_name={props.qy_name}
                            yh_id={props.yh_id}
                            yh_name={props.yh_name}
                            style={{width:'150px'}}
                            onChange={() => {}}
                        />
                    </Form.Item>
                    <Form.Item name='ddsr_bzd_danhao'>
                        <Input 
                            placeholder='团队编号' 
                           
                        />
                    </Form.Item>                    
                    <Form.Item name='ddsr_content'>
                        <Input 
                            placeholder='备注关键字' 
                           
                        />
                    </Form.Item>                    
                    <Form.Item>
                        <Space align='center' size='middle'>
                            <Icon type='search' onClick={() => {form.submit()}}/>
                            <Icon 
                                type='reset' 
                                onClick={() => {
                                    form.resetFields()
                                    setQuery({
                                        ddsr_content:''
                                    })
                                }}
                            />                          
                        </Space>
                    </Form.Item>
                </Form>
            </Flex> */}
            <Table 
                className={classes.pinkHeader}
                dataSource={list}
                columns={columns}
                pagination={false}
                size='small'
                bordered
                rowKey="key"
                summary={pageData => {
                    const total = pageData.reduce((sum, row) => sum + Number(row.ddsr_amount || 0), 0);
                    return (
                        <Table.Summary.Row>
                            <Table.Summary.Cell key="summary-0" index={0}></Table.Summary.Cell>
                            <Table.Summary.Cell key="summary-1" index={1} colSpan={1}>
                                <span style={{color:'red'}}>合计：￥{Number(total).toLocaleString('zh-CN', {
                                                                minimumFractionDigits: 2,
                                                                maximumFractionDigits: 2
                                                            })}</span>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell key="summary-2" index={2} colSpan={columns.length - 2} />
                        </Table.Summary.Row>
                    );
                }}
                locale={{
                    emptyText: '暂无收款单' // This will display text when the table is empty
                }}
            />
        </>
    )
}

export default IncomeListPendding